const BulkActionDropdown = ({ actions, disabled, onSelect }) => {
	return (
		<select
			disabled={disabled}
			className="border rounded px-3 py-2"
			defaultValue=""
			onChange={(e) => {
				if (e.target.value) {
					onSelect(e.target.value);
					e.target.value = "";
				}
			}}
		>
			<option value="" disabled>
				Select action…
			</option>
			{actions.map((a) => (
				<option key={a.id} value={a.id}>
					{a.label}
				</option>
			))}
		</select>
	);
};


export default BulkActionDropdown;